export const endpoint = {
  bowtie: (id: number) => `case/${id}/bowtie`,
  layout: 'case/bowtie/layout',
  draft: 'case/draft',
  linkedCheckListEvaluations: 'case/linkedCheckListEvaluations',
  connections: (id: number) => `case/draft/${id}/field/11850/options`,
  connectedCases: 'case/connected',
  createBowtieFavourite: 'favourite/definition/draft/template/bowtie'
};
